import BForm from "../../modules/BForm";
import BDiaryDay from "./BDiaryDay";

export default class BDiaryDayForm extends BForm
{
	getDiaryDay()
	{
		return new BDiaryDay(this.el.closest(`.diary-day`));
	}
}
